/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import CloseAction from './CloseAction/index'
import FileUploaderPluginS3 from 'DesignSystem/FileUploaderPluginS3/react'
import FileUploaderProvider from 'DesignSystem/FileUploaderProvider/react'
import ModalBody from './ModalBody/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ImportFromDevices/Content",
  restrictions
  
}) {
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Upload from devices"
/>
<CloseAction
{...childProps}
  viewPath={`${viewPath}/CloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<FileUploaderProvider
{...childProps}
  viewPath={`${viewPath}/FileUploaderProvider`}
 reset={true}
 restrictions={restrictions}
>
{childProps => (
<React.Fragment>
<ModalBody
{...childProps}
  viewPath={`${viewPath}/ModalBody`}
/>
<FileUploaderPluginS3
{...childProps}
  viewPath={`${viewPath}/FileUploaderPluginS3`}
 isLegacyBucket={true}
 excludeKeyFileExtension={true}
 prefix="tmpimg"
/>
</React.Fragment>
)}
</FileUploaderProvider>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}